import { render, staticRenderFns } from "./AccountTokenTransferTable.vue?vue&type=template&id=6290ab58&scoped=true"
import script from "./AccountTokenTransferTable.vue?vue&type=script&lang=js"
export * from "./AccountTokenTransferTable.vue?vue&type=script&lang=js"
import style0 from "./AccountTokenTransferTable.vue?vue&type=style&index=0&id=6290ab58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6290ab58",
  null
  
)

export default component.exports